import * as React from "react"

const SvgComponent = (props) => (
    <svg
        style={{
            width: 24,
            height: 24,
        }}
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M11 4h2v12l5.5-5.5 1.42 1.42L12 19.84l-7.92-7.92L5.5 10.5 11 16V4Z"
        />
    </svg>
)

export default SvgComponent
